/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import ReportList from "./components/reports/ReportList";

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Reports
Vue.component('counter', require('./components/reports/StatCounter').default);
Vue.component('report-select', require('./components/reports/ReportSelect').default);
Vue.component('report-view', require('./components/reports/ReportView').default);
Vue.component('report-summary', require('./components/reports/report/ReportSummary').default);
Vue.component('report-month', require('./components/reports/report/ReportMonth').default);
Vue.component('report-services', require('./components/reports/report/ReportServices').default);
Vue.component('report-logins', require('./components/reports/report/ReportLogins').default);
Vue.component('report-pageviews', require('./components/reports/report/ReportPageviews').default);
Vue.component('report-downloads', require('./components/reports/report/ReportDownloads').default);
Vue.component('report-calls', require('./components/reports/report/ReportCalls').default);
Vue.component('report-enquiries', require('./components/reports/report/ReportEnquiries').default);
Vue.component('report-healthchecks', require('./components/reports/report/ReportHC').default);
Vue.component('report-apps', require('./components/reports/report/ReportApps').default);
Vue.component('report-load', require('./components/reports/ReportLoad').default);
Vue.component('report-cancellation-profile', require('./components/reports/report/ReportCancellationProfile').default);
Vue.component('report-enrolment-profile', require('./components/reports/report/ReportEnrolmentProfile').default);
Vue.component('report-page-feedback', require('./components/reports/report/ReportPageFeedback').default);
Vue.component('dashboard', require('./components/dashboard/Dashboard').default);
Vue.component('dashboard-client-stats', require('./components/dashboard/ClientStats').default);
Vue.component('export-audit', require('./components/reports/ExportAudit').default);
Vue.component('manage-client-services', require('./components/ManageClientServices').default);

// Agent
Vue.component('agent-call-check', require('./components/AgentCallCheck').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/admin/reports', name:'reports', component: ReportList },
        { path: '/admin/reports/:report_year', name:'report_year', component: ReportList },
        { path: '/admin/reports/:report_year/:report_month', name:'report_year_month', component: ReportList },
    ]
})

const app = new Vue({
    el: '#app',
    components: {ReportList},
    router
});
